import { render, staticRenderFns } from "./MultiSelectReactivo.vue?vue&type=template&id=12b0a903&scoped=true"
import script from "./MultiSelectReactivo.vue?vue&type=script&lang=js"
export * from "./MultiSelectReactivo.vue?vue&type=script&lang=js"
import style0 from "./MultiSelectReactivo.vue?vue&type=style&index=0&id=12b0a903&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b0a903",
  null
  
)

export default component.exports